import axios from 'axios';
import { message } from 'antd';
import { getToken, removeToken, removeUserInfo } from './auth';
import { getStoredLocale, translateRequest } from '../i18n/messages';

// 创建axios实例
const request = axios.create({
  baseURL: '/api',
  timeout: 10000,
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    const res = response.data;
    const loc = getStoredLocale();

    // 如果返回的状态码不是200，则判断为错误
    if (res.success === false) {
      message.error(res.message || translateRequest(loc, 'failed'));

      // 401: 未授权
      if (response.status === 401) {
        removeToken();
        removeUserInfo();
        window.location.href = '/login';
      }

      return Promise.reject(new Error(res.message || translateRequest(loc, 'failed')));
    }

    return res;
  },
  (error) => {
    console.error('响应错误:', error);
    const loc = getStoredLocale();

    if (error.response) {
      switch (error.response.status) {
        case 401:
          message.error(translateRequest(loc, 'unauthorized'));
          removeToken();
          removeUserInfo();
          window.location.href = '/login';
          break;
        case 403:
          message.error(translateRequest(loc, 'forbidden'));
          break;
        case 404:
          message.error(translateRequest(loc, 'notFound'));
          break;
        case 500:
          message.error(translateRequest(loc, 'serverError'));
          break;
        default:
          message.error(error.response.data?.message || translateRequest(loc, 'failed'));
      }
    } else {
      message.error(translateRequest(loc, 'network'));
    }

    return Promise.reject(error);
  }
);

export default request;
